import { $qs } from 'fxdom/es';
import { compact, delay, each, filter, find, flatMap, go, ippL, map, some, tap } from 'fxjs/es';
import { NewMakerCvObjectCvImageF } from '../../NewMaker/CvObject/CvImage/F/Function/module/NewMakerCvObjectCvImageF.js';
import { NewMakerProductStyleS } from '../../NewMaker/ProductStyle/S/Function/module/NewMakerProductStyleS.js';
import { SVGEditorProductDetailF } from '../../SVGEditor/ProductDetail/F/Function/module/SVGEditorProductDetailF.js';
import {
  hasFullImageCvImage,
  isShadeBp,
  isShadeBpNotBlackAndWhiteContrast,
} from './CvPreview/Shade/render.js';
import { addPfToFcanvasInMaker, fitPfInFacanvasInMaker } from './draw_product_faces.js';
import { getCvObj } from './Fcanvas/cv_object.js';
import { getBaseProductInMaker, getCurrentBpId, getRealFcanvass } from './getSth.js';
import {
  changeProductColorByBpWithItsPossibleSize,
  initAfterPlacingProductFaces,
  renderNewFacesByCurrentBpcfsInMakerA,
} from './mp_maker.js';
import { hasEmbroInMaker, hasOnlyFlexInMaker } from './overflow.js';
import { render_prev_product_matcherA, unsetPrevProductColor } from './prev_product_matcher.js';
import { baseProductChangeInit } from './Product/product_fs.js';
import { openAllFacesModeA, selectFaceInitA } from './select_faces.js';
import { UtilF } from '../../Util/F/Function/module/UtilF.js';
import { alertWhenIsLocOptimizationResetByBpChange } from './LocOptimization.js';
import { onbeforeunload_event_off, removeAllDesigns } from './util.js';
import { NewMakerBaseProductsEmbroideryConstantS } from '../../NewMaker/BaseProducts/Embroidery/S/Constant/module/NewMakerBaseProductsEmbroideryConstantS.js';
import { NewMakerPropertyBaseProductConstantS } from '../../NewMaker/Property/BaseProduct/S/Constant/module/NewMakerPropertyBaseProductConstantS.js';
import { NewMakerPropertyBaseProductF } from '../../NewMaker/Property/BaseProduct/F/Function/module/NewMakerPropertyBaseProductF.js';
import { BpDiscountSetConstantS } from '../../BpDiscountSet/S/Constant/module/BpDiscountSetConstantS.js';
import { rerenderCvPreview } from './CvPreview/cv_object.js';
import { NewMakerUtilF } from '../../NewMaker/Util/F/Function/module/NewMakerUtilF.js';
import { getFlattenCvDesigns } from '@modules/NewMaker/Util/S/Function/cv_obj.ts';
import { NewMakerEndServiceF } from '@modules/NewMaker/EndService/F/Function/module/NewMakerEndServiceF.js';
import { hasNfcInMaker, initNfcProduct } from '@modules/nfc/F/Function/nfc.ts';
import { ConfigSentryF } from '@modules/Config/Sentry/F/Function/module/ConfigSentryF.js';

function makePrevProductColor() {
  const all_cv_groups = _p.map(G.mp.maker.all_designs(), function (designs) {
    return designs.length ? G.mp.maker.create_cv_group(designs) : null;
  });
  box.set('maker->prev_cv_groups', all_cv_groups);
  box.set('maker->prev_compact_cv_groups', _p.compact(all_cv_groups));
  box.set('maker->prev_product_color', box.sel('maker->product_color'));
}
function isPrevBpAndCurrentBpSimillar() {
  /* 카테고리가 같으면서 face 갯수까지 같은것 */
  const prev_face_names = go(
    box().maker.prev_product_color._.base_product_color._.base_product_color_faces,
    map((bpcf) => bpcf._.base_product_face.name),
  );
  const current_face_names = go(
    box().maker.product_color._.base_product_color._.base_product_color_faces,
    map((bpcf) => bpcf._.base_product_face.name),
  );

  return JSON.stringify(prev_face_names) === JSON.stringify(current_face_names);
}

function isPrevBpFacesLessThanCurrentBpFaces() {
  const prev_face_length = box().maker.prev_product_color.product_faces2?.value.length;
  const current_face_length =
    box().maker.product_color._.base_product_color._.base_product_color_faces?.length;
  return prev_face_length <= current_face_length;
}
function isPrevBpFacesCurrentBpFacesLength1() {
  const prev_face_length = box().maker.prev_product_color.product_faces2?.value.length;
  const current_face_length =
    box().maker.product_color._.base_product_color._.base_product_color_faces?.length;
  return prev_face_length === 1 && current_face_length === 1;
}

export function isInDetailPageInMobileInMaker() {
  return UtilF.isLegacyMobile() && !$.has_class($1('html.is_mobile_size.maker_page'), 'maker_editor_mode');
}

export function getPrevCurrentSizeFaces() {
  const prev_size_faces = _map(
    _p.range(box.sel('maker->prev_product_color->_->base_product_color->_->base_product_color_faces').length),
    (idx) => G.mp.maker.current_size_face(box().maker.prev_product_color, idx),
  );
  const current_size_faces = _map(
    _p.range(box.sel('maker->product_color->_->base_product_color->_->base_product_color_faces').length),
    (idx) => G.mp.maker.current_size_face(box().maker.product_color, idx),
  );
  return { prev_size_faces, current_size_faces };
}

export async function changeBpByBpidBasic(bp_id) {
  $.css($1('#maker'), { opacity: 0 });
  const bp = await $.get('/@api/maker/base_product', { id: bp_id });
  /* df, design_collection 상품 바꿀때 renderNewFacesByCurrentBpcfsInMakerA */
  await go(
    changeProductColorByBpWithItsPossibleSize(bp),
    () => renderNewFacesByCurrentBpcfsInMakerA(true),
    () => initAfterPlacingProductFaces(),
    () => selectFaceInitA(true),
  );
  const maker_frame_el = $qs('#maker_frame');
  if (maker_frame_el?.dataset?.is_vector === 'true') {
    const bp_option_groups_el = $qs('.bp_option_groups');
    await SVGEditorProductDetailF.vectorEditorPreviewInit(bp_option_groups_el);
  }
  $.css($1('#maker'), { opacity: 1 });
}

export function setProductNameNull(product) {
  product.name = null;
  product.name_en = null;
  product.name_jp = null;
  product.og_image_url = null;
}

export async function addPfToFcanvasInMakerForChange(product_faces, is_sequence) {
  const fcanvass = getRealFcanvass();
  await go(
    product_faces,
    ippL,
    each(async ([i, pf]) => {
      const fcanvas = is_sequence
        ? fcanvass[i]
        : go(
            fcanvass,
            find((fcanvas) => {
              return fcanvas.face_name === pf.face_name;
            }),
          );
      if (!fcanvas) return;
      await fitPfInFacanvasInMaker(pf, fcanvas, false, is_sequence);
    }),
  );
}

export async function changeSimpleBpByBpId(bp) {
  /* prev_cv_groups setting */
  makePrevProductColor();

  /* product_color setting */
  changeProductColorByBpWithItsPossibleSize(bp);

  /* url 수정 */
  // G.mp.maker.extend_state_bp(getCurrentBpId());

  /* fcanvas setting */
  await renderNewFacesByCurrentBpcfsInMakerA(true);

  /* 디자인 넣기 */
  await addPfToFcanvasInMaker(box.sel('maker->prev_product_color->product_faces2->value'));

  /*세팅 완료후 프로세스*/
  await initAfterPlacingProductFaces();
  /* prev_cv_groups 제거 */
  unsetPrevProductColor();
}

async function exceptProcess() {
  G.mp.maker.nfcProduct = null;
  G.mp.maker.flexiMaker = null;
  G.mp.maker.flexiApi = null;
  if (G.collabo_type === '') {
    if (NewMakerEndServiceF.makerStatus.isFlexiMaker()) {
      location.href = `https://www.marpple.com/${T.lang}/product/detail?bp_id=8213`;
      await delay(2000, () => {});
    } else if (hasNfcInMaker()) {
      G.mp.maker.nfcProduct = await initNfcProduct();
    }
  } else {
    if (NewMakerEndServiceF.makerStatus.isFlexiMaker()) {
      await $.alert('죄송합니다. 현재 지원하지 않는 기능입니다.<br>새로고침 됩니다.');
      location.reload();
      await delay(2000, () => {});
    } else if (hasNfcInMaker()) {
      G.mp.maker.nfcProduct = await initNfcProduct();
    }
  }
}

export async function changeBpByBpId(bp_id, is_force) {
  try {
    const hidden_cv_objs = go(
      G.mp.maker.all_designs(),
      flatMap((cv_designs) =>
        go(
          getFlattenCvDesigns(cv_designs),
          filter((cv_obj) => !(cv_obj._data._visible === true || cv_obj.visible)),
        ),
      ),
    );
    if (hidden_cv_objs?.length) {
      await $.alert(TT('NewMaker::Alert::hidden_image_remove_when_change_bp'));
      go(
        hidden_cv_objs,
        each((cv_obj) => {
          const fcanvas = cv_obj.canvas;
          cv_obj.remove();
          fcanvas.renderAll();
        }),
      );
      G.mp.maker.reset_box_data();
    }
    return await _p.go(
      _p.mr($.get('/@api/maker/base_product', { id: bp_id }), G.mp.maker.all_designs()),
      async function (bp, all_designs) {
        /* 상품 변경시 페이지 이동 */
        if (G.collabo_type === '' && $qs('.don_frame[frame_name="mp.product.detail"]')) {
          if (
            bp._?.bp_discount_set?.type === BpDiscountSetConstantS.TYPE.MP_WOW ||
            /* WOW 상품이면 */
            go(
              bp._.base_products_bp_option_groups,
              map((base_products_bp_option_group) => base_products_bp_option_group?._?.bp_option_group),
              some((bp_option_group) => bp_option_group?.is_virtual),
            ) ||
            /* 바꾸려는 상품의 옵션에 링크이동 옵션이 있다면 */
            go(
              box().maker.product_color._.base_product._.base_products_bp_option_groups,
              map((base_products_bp_option_group) => base_products_bp_option_group?._?.bp_option_group),
              some((bp_option_group) => bp_option_group?.is_virtual),
              /* 현재 상품의 옵션에 링크이동 옵션이 있다면 */
            )
          ) {
            onbeforeunload_event_off();
            NewMakerUtilF.redirectToWithLoader(`/${T.lang}/product/detail?bp_id=${bp.id}`);
            return;
          }
        }
        if (!G.mp.maker.can_embro(bp) && hasEmbroInMaker(all_designs)) {
          /* 자수 상품이 아닌데, 자수 디자인 했으면 */
          await $.alert(T('Embroidery patches are not available for this product'));
          return;
        }
        if (!G.mp.maker.can_flex(bp) && hasOnlyFlexInMaker(all_designs)) {
          /* 플렉스 상품 아닌데, 플렉스 디자인 했으면 */
          await $.alert(T('The font colors or image colors are not available for this product.'));
          return;
        }
        if (
          !$qs('#dream_factory') &&
          !is_force &&
          (NewMakerBaseProductsEmbroideryConstantS.PROPERTY.isEmbroideryApp(
            /* 자수 상품 */
            NewMakerBaseProductsEmbroideryConstantS.PROPERTY.configs,
            bp.id,
          ) ||
            NewMakerBaseProductsEmbroideryConstantS.PROPERTY.isEmbroideryApp(
              /* 자수 상품 */
              NewMakerBaseProductsEmbroideryConstantS.PROPERTY.configs,
              box.sel('maker->product_color->base_product_id'),
            ) ||
            ((bp.maker_features?.[NewMakerPropertyBaseProductConstantS.WHEN_CHANGE_REMOVE_DESIGN] ||
              box.sel('maker->product_color')._.base_product.maker_features?.[
                NewMakerPropertyBaseProductConstantS.WHEN_CHANGE_REMOVE_DESIGN
              ]) &&
              /* WHEN_CHANGE_REMOVE_DESIGN 속성 갖은 상품 */
              !NewMakerPropertyBaseProductF.whenChangeRemoveDesign.canDuplicateBpfDesigns(
                /* 복사가 가능한 조건이 아닐때만 */
                bp,
                box().maker.product_color._.base_product,
              )))
        ) {
          /* 디자인 다 없앰 */
          removeAllDesigns();
          all_designs = [];
        }

        box.unset('press_colors');
        /* 글씨 색상을 다 지움, 다른 컬러칩으로 어디선가 바뀔꺼임 */

        if (isShadeBp(bp)) {
          /* 각인 상품에는 패턴을 사용 할수 없음. 그래서 다 지움 */
          await go(
            getRealFcanvass(),
            map((fcanvas) =>
              go(
                fcanvas._objects,
                filter(
                  (cv_obj) =>
                    cv_obj._data.cv_type === 'cv_pattern' || cv_obj._data.cv_type === 'cv_text_image_pattern',
                ),
              ),
            ),
            filter((arr) => arr.length > 0),
            async (fcanvas_objs) => {
              if (fcanvas_objs.length) {
                await $.alert(
                  T(
                    `maker_error_alert::Pattern is not supported for this product. Pattern image is automatically removed.`,
                  ),
                );
                go(fcanvas_objs, each(each((cv_obj) => cv_obj.remove())));
                all_designs = G.mp.maker.all_designs();
              }
            },
          );
        }
        const cv_backgrounds = go(
          getRealFcanvass(),
          map((fcanvas) => getCvObj(fcanvas._objects, 'cv_background')),
          compact,
        );
        if (cv_backgrounds.length) {
          /* 배경 색상을 지정하던 상품이였으면 배경 색상 무조건 지움 */
          if (
            go(
              cv_backgrounds,
              some((cv_background) => cv_background.fill !== 'rgba(0,0,0,0)'),
            )
          )
            /* 이게 무슨 의도인지 모르겠음 */
            await $.alert(T('maker_error_alert::The selected background color is removed.'));
          go(
            cv_backgrounds,
            each((cv_background) => {
              cv_background.remove();
            }),
          );
        }

        if (isShadeBpNotBlackAndWhiteContrast(bp) && (await some(hasFullImageCvImage)(all_designs))) {
          /* 블랙 화이트 각인이 아닌 각인인 경우 그리고 디자인 이미지가 투명영역이 없는 경우 */
          await $.alert(
            T(
              'maker::Message::If you do not delete the background image of what you want to engrave, it will be engraved as it is, so be sure to delete the background before uploading.',
            ),
          );
        }

        if (typeof G.mp.maker.checkChangeBp === 'function') {
          const result = await G.mp.maker.checkChangeBp(bp, all_designs);
          if (!result) return;
        }

        // $.css($1('#maker'), { opacity: 0 });

        const all_designs_filtered = _p.go(
          all_designs,
          _p.filter(function (designs) {
            return designs.length;
          }),
        );
        /* 디자인 없는경우, 프린트영역이 비슷하고 면도 비슷한 상품이여서 바로 디자인이 얹혀지는 경우, 그게 아니여서 매칭이 뜬는 경우 */

        /*디자인 하나도 없을때*/
        if (all_designs_filtered.length === 0)
          return _p.go(
            changeProductColorByBpWithItsPossibleSize(bp),
            tap(() => exceptProcess()),
            () => G.mp.maker.extend_state_bp(getCurrentBpId()),
            () => renderNewFacesByCurrentBpcfsInMakerA(true),
            () => {
              if (G.collabo_type !== 'creator') {
                setProductNameNull(box.sel('maker->product_color'));
                /* 상품 변경시 product name 없애줌 */
              }
            },
            /*매칭이 안 뜨는 경우 renderNewFacesByCurrentBpcfsInMakerA */
            () => initAfterPlacingProductFaces(),
            () => selectFaceInitA(true),
            async () => {
              if (!UtilF.isLegacyMobile()) await baseProductChangeInit();
            },
          );
        return _p.go(
          ___,
          async function () {
            makePrevProductColor();
            /* prev_product_color 에 현재것을 세팅 */
            changeProductColorByBpWithItsPossibleSize(bp);
            await exceptProcess();
            if (G.collabo_type !== 'creator') {
              setProductNameNull(box.sel('maker->product_color'));
            }
            G.mp.maker.extend_state_bp(getCurrentBpId());
            await renderNewFacesByCurrentBpcfsInMakerA(true);
          },
          function () {
            const is_same = isPrevBpAndCurrentBpSimillar();
            const is_bpfs_length_1 = isPrevBpFacesCurrentBpFacesLength1();
            /*디자인한면이 한개 이거나, 비슷한 상품 일때, 라인프렌즈 detail에서 바꿀때*/
            if (is_bpfs_length_1 || is_same) {
              return _p.go(
                ___,
                function () {
                  return addPfToFcanvasInMakerForChange(
                    box.sel('maker->prev_product_color->product_faces2->value'),
                  );
                },
                /*매칭 안 뜨는 경우 renderNewFacesByCurrentBpcfsInMakerA*/
                () => initAfterPlacingProductFaces(),
                async () => {
                  const prev_product_color = box.sel('maker->prev_product_color');
                  await alertWhenIsLocOptimizationResetByBpChange({
                    pf2_values: prev_product_color.product_faces2?.value,
                  });
                  if (NewMakerProductStyleS.isNoRequestBgRemoval(getBaseProductInMaker())) {
                    NewMakerCvObjectCvImageF.makeRequestBgRemovalFalse();
                  }
                },
                unsetPrevProductColor,
                () => selectFaceInitA(true),
                async () => {
                  await go(
                    getRealFcanvass(),
                    each(async (fcanvas) => {
                      await rerenderCvPreview(fcanvas);
                    }),
                  );
                },
                async () => {
                  if (!UtilF.isLegacyMobile()) await baseProductChangeInit();
                },
              );
            } else {
              return go(
                /*매칭이 뜰 경우 renderNewFacesByCurrentBpcfsInMakerA*/
                initAfterPlacingProductFaces(false, true),
                () => render_prev_product_matcherA(),
                () => openAllFacesModeA(220),
              );
            }
          },
        );
      },
      function () {
        // /* 모든 만들기툴 세팅후 */
        // $.css($1('#maker'), { opacity: 1 });
      },
    );
  } catch (e) {
    ConfigSentryF.criticalError(e, {
      tags: { module: 'change_bp' },
    });
    $.alert(T('maker_error_alert::문제가 발생했습니다. 다시 시도해 주세요.'));
  } finally {
    $.don_loader_end();
  }
}
